import { Box, Button, Fab, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PoprchModal from "../payment/popSearch";
import { ToDate } from "../../common/toDate";
import {
  getFirstDateOfCurrentMonthPayloadFormate,
  getLastDateOfCurrentMonthPayloadFormat,
} from "../../utils/commonUtils";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { VendorRegistration } from "../vendorRegistration/vendorRegistration";
import Quatation from "../quetation/question";
// import { addPuchaseOrder, getAllProdct } from "./purchaseManagmentApi";
// import AddPuchaseOrder from "./purchaseModalAdd.jsx";
import AddIcon from "@mui/icons-material/Add";
import CardPayment from "../payment/cardPayment.jsx";
import { getAllotation, getAllProdct } from "../purchaseManagment/purchaseManagmentApi.js";
import AddPuchaseOrder from "../purchaseManagment/purchaseModalAdd.jsx";
import { routePath } from "../../constants/routePath.jsx";


export const QuetatioinPage = () => {
  const [open, setOpen] = useState(false)

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );
  const infoD = useSelector((state) => state.reducer.detail);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [collection, setCollection] = useState([])
  const cardKet = {
    persnoalInf: [
      {
        key: "id",
        label: "PO id",
        // color: "#bb4a9b",
      },
      {
        key: "mobileNumber",
        label: "mobileNumber",
        // color: "#bb4a9b",
      },
      
      {
        key: "quotationNumber",
        // color: "black",
        label: "Number quetation ",
        splitF:{target:"T",index:0}

      },
      {
        key: "quotationNumber",
        // color: "black",
        label: "quotation Number",
      },
      
      
      // {
      //   keys: ["paymentPercentage", "salaryorPercentage"],
      //   color: "#3695B6",
      //   label: "Payment Percentage",
      // },
    ],
    educationalDetail: [
      {
        key: "courseName",
        label: "Course Name",
      },
      {
        key: "courseDetails",
        label: "Component Name",
      },
      {
        key: "durationInYear",
        label: "Duration In Year",
      },
      {
        key: "percentage",
        label: "Percentage",
      },

      {
        key: "grade",
        label: "grade",
      },
      {
        key: "institute",
        label: "institute",
      },
      {
        key: "university",
        label: "university",
      },
    ],

    incentrive: [
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "percentage",
      },
    ],
    Deductions: [
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
  };
  // 10 16 15 17 18 
  useEffect(() => {
    console.log("purchase data businessChooseTab?.value", userDetail)
    if (userDetail && userDetail?.profileId) {
      let val=userDetail?.profileId?.split("?")[1]
      getAllotation({
        billerId:val.split("=")[1]?.replace(/\D/g, "") ,
      }, (res) => {
        console.log("res getall product ", res?.data)
        setCollection([...res?.data])
      })
    }
  }, [userDetail]);


const [modaldata,setModalData]=useState(null)
const [quaotaionModal,setQuotationModal]=useState(false)
  useEffect(() => {
    console.log("info d info ", infoD)
  }, [infoD])
   
    return (
      <Box> 
          {quaotaionModal &&
             <Box>
             <Quatation />
             </Box>
          }

        {!quaotaionModal &&
          <>
            <Grid container sx={{ padding: "12px" }}>
              <DynamicBreadcrumbs />
              <Grid item xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'right',
                  alignItems: "center"
                }}
  
              >
  
                <Fab
                  onClick={() => {
                    setQuotationModal(true)
                    // setOpen(true);
                    // Navigate(routePath.Quatation)
                  }}
                  sx={{
                    textTransform: "capitalize",
                    width: {
                      xs: "100%",
                      sm: "auto",
                    },
                    // p: "10px",
                    whiteSpace: "nowrap",
                  }}
                  size="small"
                  color="primary"
                  variant="extended"
                  aria-label="add"
                >
                  Add Purchase Order
                  <AddIcon />
                </Fab>
              </Grid>
              <Grid container spacing={2} sx={{mt: 1}}>
                {/* <h1>hi</h1> */}
                {collection?.map((item, index) => (
                  <Grid item xs={4} key={index}>
                    <CardPayment
                      item={item}
                      setOpen={(data) => { }}
                      setModalData={(dat) => {
                        console.log("upupupupup ", dat)
                        let obj = {}
                        Object.keys(dat).map((key, index) => {
                          if (dat[key] && dat[key] != "null") {
                            obj[key] = dat[key]
                          }
                          else {
                            obj[key] = ""
                          }
                        })
                        console.log("objobjobjobj", obj)
  
                        // setModalData({...obj,
                        // });
                        setModalData(item)
                        setOpen(true);
  
                        // setModalDataT(obj);
                        // setOpenT(true);
  
                      }}
                      cardKet={cardKet?.persnoalInf}
                    />
                  </Grid>
                ))}
              </Grid>
  
              <AddPuchaseOrder  
              getAllData={()=>{
                if (userDetail && userDetail?.profileId) {
                  let val=userDetail?.profileId?.split("?")[1]
                  getAllProdct({
                    billerId:val.split("=")[1]?.replace(/\D/g, "") ,
                  }, (res) => {
                    console.log("res getall product ", res?.data)
                    setCollection([...res?.data])
                  })
                }
              }} modaldata={modaldata} open={open} setOpen={setOpen} setModalData={setModalData}  />
            </Grid>
          </>
        }
        {/* {businessChooseTab?.value == "VenderRegistration" &&
          <VendorRegistration />} */}
        {/* {businessChooseTab?.value == "Quotation" &&
          <Quatation />} */}
      </Box>
    );
   
};
